import styled from 'styled-components';
import { Link } from 'gatsby';

const StyledNavLink = styled(Link).attrs(() => ({ state: { via: 'NavLink' } }))`
  display: block;
  padding: 1rem;
  text-decoration: none;
`;

export default StyledNavLink;
